import type { ReactNode } from 'react'
import type { AlarmLevel } from '@/types'
import { cn } from '@/lib/utils'

// #413 — the icon that goes with the word: a diamond for Suspicious, a triangle for Critical (never colour alone).
export function LevelIcon({ level, className }: { level: AlarmLevel; className?: string }) {
  return (
    <svg
      aria-hidden
      data-level-icon={level}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('inline-block shrink-0 align-[-3px]', className)}
    >
      {level === 'suspicious' ? (
        <>
          <path d="M12 2.5 21.5 12 12 21.5 2.5 12Z" />
          <path d="M12 8v5" />
          <path d="M12 16.5h.01" />
        </>
      ) : (
        <>
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
        </>
      )}
    </svg>
  )
}

/** #413 — the solid band that opens a NEW Suspicious / Critical row or card: white on a dark band, icon, word, reasons.
 *  Gone once someone presses Seen / Acknowledge (the row then shows the muted inline label).
 *  `ariaHidden` (final review I2): a Dashboard row, whose open button repeats the band's words for screen readers, hides
 *  the band from them so it is said once; an Events card leaves it visible (the band names the card). */
export function LevelBand({ level, id, ariaHidden, children }: { level: AlarmLevel; id?: string; ariaHidden?: boolean; children: ReactNode }) {
  return (
    <div
      id={id}
      aria-hidden={ariaHidden ? true : undefined}
      className={cn('level-band', level === 'suspicious' ? 'level-band--sus' : 'level-band--crit')}
    >
      <LevelIcon level={level} />
      <span>{children}</span>
    </div>
  )
}
